import React, { useEffect, useState } from 'react';
import i18n from 'i18next';
import useSessionStorage from '../hooks/useSessionStorage';
import { post } from '../services/api';
import Spinner from './Spinner';

interface ValidateProps {
  clubId: string | null;
  clubHash: string | null;
  clubUrl: URL | null;
  callback: Function;
}

function Validate({ clubId, clubHash, clubUrl, callback }: ValidateProps) {
  const [error, setError] = useState(null);
  const [initData, setInitData] = useSessionStorage('init-data', null);

  useEffect(() => {
    (async () => {
      // We don't cache anything right now. We need to refetch campaign data on every load.
      // if (initData?.token && initData.settings.golfclubId === parseInt(String(clubId), 10)) {
      //   callback(initData);
      //   return;
      // }

      if (!clubId || !clubHash) {
        setError('Missing parameters, make sure clubId and clubHash are set');
        return;
      }

      const { response, error: err } = await post('init', {
        clubId,
        clubHash,
        clubUrl
        // clubOrigin
      });

      if (response?.settings?.name) {
        i18n.changeLanguage(response.settings.language);
        setInitData(response);
        callback(response);
      } else {
        setError(err || 'Something went wrong, please contact Golfamore');
      }
    })();
  }, [initData]);

  return error ? (
    <p className="golfamore-error" style={{ padding: 30 }}>
      {error}
    </p>
  ) : (
    <Spinner />
  );
}

export default Validate;
